<template>
  <div class="contract-probation-addon">
    <div class="addon-head">
      <div>
        <span>HRM_CONTRACT_PROBATION_ALERT</span>
        <h2>试用期与合同预警</h2>
        <p>基于员工入职时间、状态、部门和关键资料字段，识别即将转正、长期未转正和合同资料缺口。</p>
      </div>
      <el-button type="primary" icon="el-icon-refresh" :loading="loading" @click="loadData">刷新</el-button>
    </div>

    <el-row :gutter="16" class="metric-row">
      <el-col v-for="item in metrics" :key="item.label" :xs="24" :sm="12" :lg="6">
        <div class="metric-card" :class="item.tone">
          <span>{{ item.label }}</span>
          <strong>{{ item.value }}</strong>
          <em>{{ item.meta }}</em>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="16">
      <el-col :xs="24" :lg="12">
        <el-card shadow="never">
          <div slot="header">即将转正提醒</div>
          <el-table :data="overview.dueSoonStaffList" size="small" v-loading="loading" empty-text="暂无即将到期人员">
            <el-table-column prop="staff_name" label="员工" width="110" />
            <el-table-column prop="dept_name" label="部门" min-width="120" />
            <el-table-column prop="entry_date" label="入职日期" width="110" />
            <el-table-column prop="probation_due_date" label="到期日" width="110" />
            <el-table-column prop="days_left" label="剩余天数" width="90" />
          </el-table>
        </el-card>
      </el-col>
      <el-col :xs="24" :lg="12">
        <el-card shadow="never">
          <div slot="header">长期未转正风险</div>
          <el-table :data="overview.overdueStaffList" size="small" v-loading="loading" empty-text="暂无逾期人员">
            <el-table-column prop="staff_name" label="员工" width="110" />
            <el-table-column prop="dept_name" label="部门" min-width="120" />
            <el-table-column prop="entry_date" label="入职日期" width="110" />
            <el-table-column prop="employed_days" label="在职天数" width="90" />
            <el-table-column prop="probation_due_date" label="应转正日" width="110" />
          </el-table>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="16" class="lower-row">
      <el-col :xs="24" :lg="12">
        <el-card shadow="never">
          <div slot="header">部门合同风险排行</div>
          <el-table :data="overview.deptRiskRanking" size="small" v-loading="loading">
            <el-table-column prop="dept_name" label="部门" min-width="120" />
            <el-table-column prop="active_count" label="在职" width="70" />
            <el-table-column prop="due_soon_count" label="即将到期" width="90" />
            <el-table-column prop="overdue_count" label="逾期" width="70" />
            <el-table-column prop="contract_missing_count" label="资料缺口" width="90" />
          </el-table>
        </el-card>
      </el-col>
      <el-col :xs="24" :lg="12">
        <el-card shadow="never">
          <div slot="header">合同资料缺口</div>
          <el-table :data="overview.contractMissingList" size="small" v-loading="loading" empty-text="暂无资料缺口">
            <el-table-column prop="staff_name" label="员工" width="110" />
            <el-table-column prop="dept_name" label="部门" min-width="120" />
            <el-table-column prop="entry_date" label="入职日期" width="110" />
            <el-table-column prop="missing_reason" label="缺口原因" min-width="130" />
          </el-table>
        </el-card>
      </el-col>
    </el-row>

    <el-card class="lower-row" shadow="never">
      <div slot="header">月度入职趋势</div>
      <div class="trend-list">
        <div v-for="item in overview.monthlyEntryTrend" :key="item.month_label" class="trend-item">
          <span>{{ item.month_label }}</span>
          <strong>{{ item.entry_count }}</strong>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getContractProbationAlertOverview } from '../api/contractProbationAlert'

export default {
  name: 'ContractProbationAlertOverview',
  data () {
    return {
      loading: false,
      overview: {
        activeStaffCount: 0,
        probationStaffCount: 0,
        dueSoonCount: 0,
        overdueCount: 0,
        contractInfoMissingCount: 0,
        probationDays: 90,
        remindDays: 15,
        deptRiskRanking: [],
        dueSoonStaffList: [],
        overdueStaffList: [],
        contractMissingList: [],
        monthlyEntryTrend: []
      }
    }
  },
  computed: {
    metrics () {
      return [
        { label: '在职员工', value: this.overview.activeStaffCount, meta: '当前有效人员' },
        { label: '试用期内', value: this.overview.probationStaffCount, meta: `${this.overview.probationDays} 天规则`, tone: 'blue' },
        { label: '即将转正', value: this.overview.dueSoonCount, meta: `${this.overview.remindDays} 天内`, tone: 'orange' },
        { label: '资料/逾期风险', value: this.overview.contractInfoMissingCount, meta: `${this.overview.overdueCount} 个逾期`, tone: 'red' }
      ]
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.loading = true
      getContractProbationAlertOverview().then(response => {
        if (response.code === 200) {
          this.overview = Object.assign({}, this.overview, response.data || {})
        } else {
          this.$message.warning(response.message || '试用期与合同预警加载失败')
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.contract-probation-addon {
  padding: 20px;
  background: #f5f7fb;
  min-height: 100%;
}

.addon-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
  padding: 22px 24px;
  background: #ffffff;
  border: 1px solid #e6ebf2;
  border-radius: 6px;
}

.addon-head span {
  display: block;
  margin-bottom: 8px;
  color: #075985;
  font-size: 12px;
  font-weight: 700;
}

.addon-head h2 {
  margin: 0 0 8px;
  color: #17233d;
  font-size: 24px;
}

.addon-head p {
  margin: 0;
  color: #5f6f89;
}

.metric-row {
  margin-bottom: 16px;
}

.metric-card {
  min-height: 118px;
  padding: 18px;
  margin-bottom: 16px;
  background: #ffffff;
  border: 1px solid #e6ebf2;
  border-radius: 6px;
}

.metric-card span,
.metric-card em {
  display: block;
  color: #6b7a90;
  font-style: normal;
}

.metric-card strong {
  display: block;
  margin: 10px 0 8px;
  color: #17233d;
  font-size: 30px;
  line-height: 1;
}

.metric-card.red strong {
  color: #d93026;
}

.metric-card.orange strong {
  color: #d9822b;
}

.metric-card.blue strong {
  color: #2f6fec;
}

.lower-row {
  margin-top: 16px;
}

.trend-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 10px;
}

.trend-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  background: #f8fafc;
  border: 1px solid #edf1f7;
  border-radius: 6px;
}

.trend-item span {
  color: #5f6f89;
}

.trend-item strong {
  color: #17233d;
  font-size: 16px;
}
</style>
